import { Alert } from 'antd';
import useMultiLanguageSignIn from 'page/Authentication/SignIn/hook/useMultiLanguageSignIn';
import { useEffect, useState } from 'react';
import confirmIcon from '../../../assets/logo/confirm-signup-email.svg';
import ImageIcon from 'page/Authentication/component/Image';

const ConfirmSignupEmail = () => {
  const { MAINTENANCE_MESSAGE } = useMultiLanguageSignIn();

  // start get maintenance information
  const [yyyy, setyyyy] = useState();
  const [MM, setMM] = useState();
  const [dd, setdd] = useState();
  const [hh, sethh] = useState();
  const [mm, setmm] = useState();
  const [isMaintenance, setMaintenance] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('./maintenancetimeconfig.json');
        const jsonData = await response.json();
        setyyyy(jsonData.yyyy);
        setMM(jsonData.MM);
        setdd(jsonData.dd);
        sethh(jsonData.hh);
        setmm(jsonData.mm);
        setMaintenance(jsonData.isMaintenance);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData().then();
  }, []);

  const message = MAINTENANCE_MESSAGE.replace('{yyyy}', yyyy)
    .replace('{MM}', MM)
    .replace('{dd}', dd)
    .replace('{hh}', hh)
    .replace('{mm}', mm);

  const formattedMessage = message.split('\n').map((str, index, arr) => (
    <span key={index}>
      {str}
      {index < arr.length - 1 && <br />}
    </span>
  ));

  return (
    <div>
      {isMaintenance && (
        <Alert
          message={formattedMessage}
          type="error"
          style={{ paddingLeft: '30px' }}
        />
      )}

      <div className="confirm-signup-email">
        <ImageIcon src={confirmIcon} alt="confirm icon"/>
        <p className="title">本人確認メールを送信しました</p>
        <p className="description">
          メールをご確認の上、本人確認用リンクをクリック
        </p>
        <p className="description">して登録を完了してください。</p>
      </div>
    </div>
  );
};

export default ConfirmSignupEmail;
